<template>
  <div id="Player"> </div>
</template>

<script>
import WasmPlayer from '@easydarwin/easywasmplayer';

export default {
  name: "Live",
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.getFlv();
  },
  methods: {
    getFlv() {
      const url = process.env.VUE_APP_RTMP + `/live/${this.detail.sn}`;
      this.sendCmd([{ type: "invoke_method", data: { methodName: "start_live", methodParams: { url } } }], "get").then(() => {
        this.player = new WasmPlayer('', 'Player', () => { });
        this.player.play(`${process.env.VUE_APP_FLV || (location.origin + '/live/')}${this.detail.sn}.flv`, 1)
      });
    },
    async sendCmd(commands_info, type = "set") {

      const { id, sn, type_id, name } = this.detail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      await this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, res => {
        console.log(res);
      });
    },
  }
}
</script>

<style>
</style>